function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { login as _login, phoneLogin, logout as _logout, userScanStatusApi } from '@/api/user';
import { frameUserApi, frameTreeApi } from '@/api/public';
import { getDictTreeListApi } from '@/api/form';
import router, { resetRouter } from '@/router';
var state = {
  token: localStorage.getItem('token') || '',
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  menuList: [],
  menuAuthor: [],
  formDicList: [],
  // 字典列表-就不用重复请求接口
  departmentList: [],
  // 部门列表-就不用重复请求接口
  memberList: [],
  // 人员列表-就不用重复请求接口
  isLogin: false,
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
  enterprise: localStorage.getItem('enterprise') ? JSON.parse(localStorage.getItem('enterprise')) : null,
  messageCount: 0,
  permissions: []
};
var mutations = {
  SET_MENU_LIST: function SET_MENU_LIST(state, menuList) {
    state.menuList = menuList;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_MENU_AUTHOR: function SET_MENU_AUTHOR(state, menuAuthor) {
    state.menuAuthor = menuAuthor;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  SET_ISLOGIN: function SET_ISLOGIN(state, isLogin) {
    state.isLogin = isLogin;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  // 修改字典列表数据
  SET_FORMDIC: function SET_FORMDIC(state, data) {
    state.formDicList.push(data);
  },
  // 修改部门列表数据
  SET_DEPARTMENT: function SET_DEPARTMENT(state, data) {
    state.departmentList = data;
  },
  // 修改人员列表数据
  SET_MEMBER: function SET_MEMBER(state, data) {
    state.memberList = data;
  },
  // 重置字典列表数据
  REMOVE_FORMDIC: function REMOVE_FORMDIC(state, data) {
    state.formDicList = data;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USERINFO: function SET_USERINFO(state, data) {
    state.userInfo = data;
    localStorage.setItem('userInfo', JSON.stringify(data));
  },
  SET_ENTINFO: function SET_ENTINFO(state, data) {
    state.enterprise = data;
    localStorage.setItem('enterprise', JSON.stringify(data));
  },
  SET_MESSAGE: function SET_MESSAGE(state, count) {
    state.messageCount = count;
  }
};
var actions = {
  // 获取自定义表单关联字典数据
  getDictList: function getDictList(_ref, val) {
    var commit = _ref.commit,
      state = _ref.state;
    return new Promise(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
        var is_next, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              is_next = state.formDicList.some(function (item) {
                return item.dict_ident == val.types;
              });
              if (!(!state.formDicList || !is_next)) {
                _context.next = 9;
                break;
              }
              _context.next = 4;
              return getDictTreeListApi(val);
            case 4:
              response = _context.sent;
              _context.next = 7;
              return commit('SET_FORMDIC', {
                dict_ident: val.types,
                list: response.data
              });
            case 7:
              _context.next = 9;
              return resolve(state.formDicList);
            case 9:
              resolve(state.formDicList);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  // 获取人员数据
  getMember: function getMember(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
        var data, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                role: 0,
                leave: 0
              };
              _context2.next = 3;
              return frameUserApi(data);
            case 3:
              response = _context2.sent;
              _context2.next = 6;
              return commit('SET_MEMBER', response.data[0].children);
            case 6:
              _context2.next = 8;
              return resolve(state.memberList);
            case 8:
              resolve(state.memberList);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }());
  },
  // 获取部门数据
  getDepartment: function getDepartment(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new Promise(/*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return frameTreeApi();
            case 2:
              response = _context3.sent;
              _context3.next = 5;
              return commit('SET_DEPARTMENT', response.data);
            case 5:
              _context3.next = 7;
              return resolve(state.departmentList);
            case 7:
              resolve(state.departmentList);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x5, _x6) {
        return _ref6.apply(this, arguments);
      };
    }());
  },
  login: function login(_ref7, data) {
    var commit = _ref7.commit;
    return new Promise(/*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
        var response, _response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(data.activeName === 'passwordLogin')) {
                _context4.next = 12;
                break;
              }
              _context4.next = 3;
              return _login(data.userInfo);
            case 3:
              response = _context4.sent;
              _context4.next = 6;
              return commit('SET_TOKEN', response.data.token);
            case 6:
              _context4.next = 8;
              return commit('SET_ISLOGIN', true);
            case 8:
              _context4.next = 10;
              return resolve(response.data);
            case 10:
              _context4.next = 21;
              break;
            case 12:
              _context4.next = 14;
              return phoneLogin(data.userInfo);
            case 14:
              _response = _context4.sent;
              _context4.next = 17;
              return commit('SET_TOKEN', _response.data.token);
            case 17:
              _context4.next = 19;
              return commit('SET_ISLOGIN', true);
            case 19:
              _context4.next = 21;
              return resolve(data);
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x7, _x8) {
        return _ref8.apply(this, arguments);
      };
    }());
  },
  scanLogin: function scanLogin(_ref9, data) {
    var commit = _ref9.commit;
    return new Promise(/*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
        var response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return userScanStatusApi(data);
            case 2:
              response = _context5.sent;
              if (response.data.status === undefined) {
                commit('SET_TOKEN', response.data.token);
                commit('SET_ISLOGIN', true);
              }
              resolve(response.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x9, _x10) {
        return _ref10.apply(this, arguments);
      };
    }());
  },
  // get user info
  getInfo: function (_getInfo) {
    function getInfo(_x11) {
      return _getInfo.apply(this, arguments);
    }
    getInfo.toString = function () {
      return _getInfo.toString();
    };
    return getInfo;
  }(function (_ref11) {
    var commit = _ref11.commit,
      state = _ref11.state;
    return new Promise(function (resolve, reject) {
      getInfo(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          name = data.name,
          avatar = data.avatar,
          introduction = data.introduction;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }),
  // user logout
  logout: function logout(_ref12) {
    var commit = _ref12.commit,
      state = _ref12.state,
      dispatch = _ref12.dispatch;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_MENU_LIST', []);
        commit('SET_MENU_AUTHOR', []);
        commit('SET_USERINFO', '');
        commit('SET_ISLOGIN', false);
        localStorage.removeItem('userInfo');
        localStorage.removeItem('menuList');
        localStorage.removeItem('menuAuthor');
        localStorage.removeItem('enterprise');
        localStorage.removeItem('token');
        localStorage.removeItem('menuTabData');
        localStorage.removeItem('articleList');
        localStorage.removeItem('sidebarParentCur');
        localStorage.removeItem('categoryList');
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref13) {
    var commit = _ref13.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_MENU_LIST', '');
      commit('SET_USERINFO', '');
      commit('SET_ENTINFO', '');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('entMenuList');
      localStorage.removeItem('enterprise');
      localStorage.removeItem('sidebarParentCur');
      localStorage.removeItem('entMenuAuthor');
      localStorage.removeItem('menuTabData');
      localStorage.removeItem('categoryList');
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref14, role) {
    var commit = _ref14.commit,
      dispatch = _ref14.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              _context6.next = 4;
              return dispatch('getInfo');
            case 4:
              _yield$dispatch = _context6.sent;
              roles = _yield$dispatch.roles;
              resetRouter();
              _context6.next = 9;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 9:
              accessRoutes = _context6.sent;
              router.addRoutes(accessRoutes);
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x12) {
        return _ref15.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};